import { ReactNode, createContext, useContext, useState } from "react";
import CancelTripRequestModal from "./CancelTripRequestModal";
import { ITripRequest } from "models/tripRequest";

interface ITripRequestAlertProps {
  showCancel: (tripRequest: ITripRequest) => void;
}

export const TripRequestAlertContext = createContext<ITripRequestAlertProps>(
  {} as ITripRequestAlertProps
);

export const useTripRequestAlertContext = () =>
  useContext<ITripRequestAlertProps>(TripRequestAlertContext);

interface IOpen {
  open: boolean;
  tripRequest: ITripRequest | null;
}

export function TripRequestAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openBan, setOpenBan] = useState<IOpen>({
    open: false,
    tripRequest: null,
  });

  const showCancel = (tripRequest: ITripRequest) =>
    setOpenBan({ open: true, tripRequest });
  const handleCloseBan = () => setOpenBan({ open: false, tripRequest: null });

  return (
    <TripRequestAlertContext.Provider value={{ showCancel }}>
      {openBan.tripRequest && (
        <CancelTripRequestModal
          open={openBan.open}
          tripRequest={openBan.tripRequest}
          handleClose={handleCloseBan}
        />
      )}
      {children}
    </TripRequestAlertContext.Provider>
  );
}
